import React, { useEffect, useState } from 'react';
import './SideNavBarComponent.scss';
import { ImImages } from 'react-icons/im';
import { IoIosArrowForward, IoNewspaperSharp } from 'react-icons/io';
import { IoDocumentText } from 'react-icons/io5';
import { FaArrowLeft, FaUser } from 'react-icons/fa';
import { AiFillProject, AiFillMessage } from 'react-icons/ai';
import { NavLink } from 'react-router-dom';
import { RiMenuUnfoldLine, RiMenuFoldLine, RiNewspaperFill } from 'react-icons/ri';
import { useStateValue } from '../../../services/ContextProvider';
import { userRoleReadable } from '../../../services/userService';
import { GoSignOut } from 'react-icons/go';
import { signOut } from '../../../services/AuthService';

export const DashBoardHeadSection = (icon, sectionTitle) => {
	return (
		<div className="section-head">
			{icon()}
			<div className="head-text">
				{sectionTitle}
			</div>
		</div>
	);
};

const SideNavBarComponent = () => {
	const { userState, globalDispatch, userDispatch } = useStateValue();
	const [menu, setmenu] = useState(false);
	const [user, setUser] = useState(userState.loggedUserData);

	useEffect(() => setUser(userState.loggedUserData), [userState.loggedUserData]);

	useEffect(() => {
		console.log(user);
	}, [user]);

	const showMenu = () => {
		setmenu(true);
	};

	const hideMenu = () => {
		setmenu(false);
	};

	const handleLogOut = async () => {
		await signOut(globalDispatch, userDispatch);
	};

	if (user === null) {
		return (<></>);
	} else {

		return (
			<>
				{!menu &&
					<div className="toggle-icon-show" onClick={showMenu}>
						<RiMenuUnfoldLine />
					</div>
				}
				{menu &&
					<div className="toggle-icon-show hide" onClick={hideMenu}>
						<RiMenuFoldLine />
					</div>
				}
				<div className={menu ? 'side-nav active' : 'side-nav'}>
					<div className="side-nav-title-section">
						<div className="side-nav-logo-section">
							<div className="side-nav-logo-container">
								<img className="side-nav-logo" src="/images/logo/logo1.png" alt="logo" />
							</div>
							<div className="side-nav-title">
								Leo Club of <b>Colombo Monarch</b>
							</div>
						</div>
						<div className="side-nav-sub-title">
							Website Admin Panel
						</div>
					</div>
					<div className='head-section'>
						<div className="avatar-container">
							<img src={user.photoURL} alt="avatar" className="avatar-image" />
						</div>
						<div className="name-section">
							<div className="user-name">{user.displayName}</div>
							<div className="user-role">{userRoleReadable(user.role)}</div>
							<div className="signOut-sidenav-btn" onClick={handleLogOut}>
								<span className="signin-icon"><GoSignOut /></span> Sign Out
							</div>
						</div>
					</div>
					<hr className="head-divider" />

					<NavLink to="/admin-panel" exact className="side-nav-item" onClick={hideMenu}>
						<div className="side-nav-item-content">
							<div className="side-item-icon">
								<AiFillProject />
							</div>
							<div className="side-item-text">
								Add Projects
							</div>
						</div>
						<div className="side-item-icon-arr">
							<IoIosArrowForward />
						</div>
					</NavLink>

					<NavLink to="/admin-panel/manage-carousel" exact className="side-nav-item" onClick={hideMenu}>
						<div className="side-nav-item-content">
							<div className="side-item-icon">
								<ImImages />
							</div>
							<div className="side-item-text">
								Manage Carousel
							</div>
						</div>
						<div className="side-item-icon-arr">
							<IoIosArrowForward />
						</div>
					</NavLink>

					<NavLink to="/admin-panel/contactusresponses" className="side-nav-item" onClick={hideMenu}>
						<div className="side-nav-item-content">
							<div className="side-item-icon">
								<AiFillMessage />
							</div>
							<div className="side-item-text">
								Messages
							</div>
						</div>
						<div className="side-item-icon-arr">
							<IoIosArrowForward />
						</div>
					</NavLink>

					<NavLink to="/admin-panel/subscribers" className="side-nav-item" onClick={hideMenu}>
						<div className="side-nav-item-content">
							<div className="side-item-icon">
								<RiNewspaperFill />
							</div>
							<div className="side-item-text">
								NewsLetter Subscribers
							</div>
						</div>
						<div className="side-item-icon-arr">
							<IoIosArrowForward />
						</div>
					</NavLink>

					<NavLink to="/admin-panel/user-accounts" className="side-nav-item" onClick={hideMenu}>
						<div className="side-nav-item-content">
							<div className="side-item-icon">
								<FaUser />
							</div>
							<div className="side-item-text">
								User Accounts
							</div>
						</div>
						<div className="side-item-icon-arr">
							<IoIosArrowForward />
						</div>
					</NavLink>

					<NavLink to="/" exact className="side-nav-item back-btn" onClick={hideMenu}>
						<div className="side-nav-item-content">
							<div className="side-item-icon">
								<FaArrowLeft />
							</div>
							<div className="side-item-text">
								Back to home
							</div>
						</div>
					</NavLink>
				</div>
			</>
		);
	}
};

export default SideNavBarComponent;
